import locationTagsTemplate from './locationTags.html';
import './locationTags.scss';

export default angular
  .module('main.locations.edit.components.tags', [])

  .directive('editLocationTags', () => {
    return {
      restrict: 'E',
      template: locationTagsTemplate,
      scope: {},
      controller: ($scope,
                   $q,
                   $interval,
                   EditLocationDataProvider) => {
        $scope.dataProvider = EditLocationDataProvider.instance;
        $scope.loading = true;

        // Refresh tags interval
        const REFRESH_INTERVAL = 20000;
        let locationTagsUpdateInterval;

        $scope.$on('$destroy', () => {
          if (locationTagsUpdateInterval) {
            $interval.cancel(locationTagsUpdateInterval);
          }
        });

        init();

        function init() {

          $q.all([
            $scope.dataProvider.locationResource.init(),
            $scope.dataProvider.locationOrganizationResource.init(),
            $scope.dataProvider.locationHighlightsResource.init(),
          ])
            .then(() => {
              $scope.loading = false;

              $scope.tags = angular.copy($scope.dataProvider.locationResource.value.tags || [])
                .filter(tag => tag.category !== 2); // Exclude group tags

              $scope.highlights = angular.copy($scope.dataProvider.locationHighlightsResource.value);
              if ($scope.highlights && $scope.highlights.length > 0) {
                locationTagsUpdateInterval = $interval(() => {
                  refreshTags();
                }, REFRESH_INTERVAL);
              }
            });

          $scope.$on('deleteTagsCompleteEvent', function(event, data) {
            event.preventDefault();
          });

          $scope.$on('addTagsCompleteEvent', function(event, data) {
            event.preventDefault();
          });

        }

        function refreshTags() {
          if ($scope.highlights && $scope.highlights.length > 0 && $scope.dataProvider.activeTab === 'dashboard') {
            $q.all([
              $scope.dataProvider.locationResource.init(true),
              $scope.dataProvider.locationHighlightsResource.init(true),
            ])
              .then(() => {
                $scope.highlights = angular.copy($scope.dataProvider.locationHighlightsResource.value);
                $scope.tags = angular.copy($scope.dataProvider.locationResource.value.tags || [])
                  .filter(tag => tag.category !== 2); // Exclude group tags

              });
          }
        }

      }
    };
  })
  .name;
